export const translations = {
    vi: {
        nav: {
            home: "Trang chủ",
            about: "Giới thiệu",
            services: "Dịch vụ",
            projects: "Dự án",
            blog: "Blog",
            contact: "Liên hệ",
            cta: "Bắt đầu dự án",
        },
        home: {
            eyebrow: "Công ty TNHH Công nghệ & Nguồn lực MAXTH",
            heroLine1: "Kiến tạo phần mềm.",
            heroLine2: "Định hình tương lai số.",
            heroSub:
                "MAXTH Solutions là công ty phát triển phần mềm đặt trụ sở tại TP. Hồ Chí Minh. Chúng tôi thiết kế và xây dựng ứng dụng web, di động và hệ thống quy mô lớn — chuẩn mực kỹ thuật quốc tế, tối ưu cho doanh nghiệp Việt.",
            ctaPrimary: "Bắt đầu dự án",
            ctaSecondary: "Khám phá dịch vụ",
            scrollHint: "Cuộn xuống",
            stats: [
                { value: 20, suffix: "+", decimals: 0, label: "Dự án đã bàn giao" },
                { value: 12, suffix: "+", decimals: 0, label: "Đối tác doanh nghiệp" },
                { value: 99.9, suffix: "%", decimals: 1, label: "Cam kết uptime hệ thống" },
                { value: 24, suffix: "/7", decimals: 0, label: "Hỗ trợ kỹ thuật" },
            ],
            aboutEyebrow: "Về chúng tôi",
            aboutTitle: "Kỹ thuật chính xác. Tư duy sản phẩm.",
            aboutText1:
                "MAXTH Solutions (MST: 0319622735) hoạt động với một niềm tin duy nhất: phần mềm tốt được tạo ra từ sự chính xác trong từng dòng code và sự thấu hiểu sâu sắc bài toán kinh doanh của khách hàng.",
            aboutText2:
                "Từ hệ thống nội bộ cho doanh nghiệp đến những sản phẩm phục vụ hàng nghìn người dùng như Temp Mail, chúng tôi theo đuổi chất lượng kỹ thuật không thỏa hiệp — kiến trúc rõ ràng, hiệu năng cao, bảo mật là mặc định.",
            aboutPoints: [
                "Đội ngũ kỹ sư full-stack giàu kinh nghiệm thực chiến",
                "Quy trình phát triển minh bạch, báo cáo tiến độ hàng tuần",
                "Bảo mật và quyền riêng tư là ưu tiên mặc định",
                "Bàn giao đầy đủ mã nguồn và tài liệu kỹ thuật",
            ],
            aboutLink: "Tìm hiểu thêm về MAXTH",
            servicesEyebrow: "Dịch vụ",
            servicesTitle: "Năng lực kỹ thuật toàn diện",
            servicesSub:
                "Từ ý tưởng đến sản phẩm vận hành thực tế — chúng tôi nhận trọn vòng đời phát triển phần mềm.",
            viewAllServices: "Xem tất cả dịch vụ",
            featuredEyebrow: "Sản phẩm tiêu biểu",
            featuredBadge: "Đang vận hành",
            featuredText:
                "Temp Mail là nền tảng email tạm thời do chính đội ngũ MAXTH phát triển và vận hành — giúp người dùng nhận thư mà không tiết lộ địa chỉ email thật, chống spam và bảo vệ danh tính trực tuyến.",
            featuredPoints: [
                "Tạo địa chỉ email tức thì, không cần đăng ký",
                "Hộp thư tự hủy, không lưu trữ dữ liệu cá nhân",
                "Giao diện tối giản, tốc độ tải dưới 1 giây",
                "Phục vụ hàng nghìn lượt sử dụng mỗi tháng",
            ],
            visitSite: "Trải nghiệm tại maxthsolutions.org",
            projectsEyebrow: "Dự án",
            projectsTitle: "Sản phẩm chúng tôi đã xây dựng",
            viewAllProjects: "Xem tất cả dự án",
            blogEyebrow: "Blog kỹ thuật",
            blogTitle: "Chia sẻ từ phòng lab",
            viewAllBlog: "Đọc tất cả bài viết",
            readMore: "Đọc tiếp",
            ctaTitle: "Có một ý tưởng cần hiện thực hóa?",
            ctaText:
                "Hãy kể cho chúng tôi về bài toán của bạn. Đội ngũ kỹ sư MAXTH sẽ phản hồi trong vòng 24 giờ làm việc với đề xuất giải pháp cụ thể.",
            ctaButton: "Liên hệ ngay",
        },
        services: {
            items: [
                {
                    id: "web",
                    title: "Phát triển Web App",
                    desc: "Ứng dụng web hiện đại, tải nhanh, chuẩn SEO và dễ mở rộng — từ cổng thông tin doanh nghiệp đến nền tảng SaaS phức tạp.",
                    tags: ["React", "Next.js", "Node.js", "TypeScript"],
                },
                {
                    id: "mobile",
                    title: "Ứng dụng di động",
                    desc: "Ứng dụng iOS & Android mượt mà như native với một codebase duy nhất, phát hành đồng thời trên cả hai kho ứng dụng.",
                    tags: ["React Native", "Flutter", "iOS", "Android"],
                },
                {
                    id: "api",
                    title: "API & Hệ thống Backend",
                    desc: "Thiết kế API chuẩn REST/GraphQL, kiến trúc microservices, xử lý hàng triệu request với độ trễ thấp và khả năng mở rộng ngang.",
                    tags: ["Node.js", "Python", "Go", "PostgreSQL", "Redis"],
                },
                {
                    id: "cloud",
                    title: "Cloud & DevOps",
                    desc: "Triển khai hạ tầng trên AWS/GCP, container hóa với Kubernetes, CI/CD tự động hóa và giám sát toàn diện 24/7.",
                    tags: ["AWS", "GCP", "Kubernetes", "Terraform"],
                },
                {
                    id: "security",
                    title: "Bảo mật & Quyền riêng tư",
                    desc: "Đánh giá bảo mật, kiểm thử xâm nhập và thiết kế hệ thống theo triết lý privacy-first — như cách chúng tôi xây dựng Temp Mail.",
                    tags: ["Pen-testing", "OWASP", "Mã hóa", "Audit"],
                },
                {
                    id: "consulting",
                    title: "Tư vấn chuyển đổi số",
                    desc: "Đồng hành cùng doanh nghiệp từ khâu phân tích bài toán, lựa chọn công nghệ đến lộ trình triển khai và vận hành dài hạn.",
                    tags: ["Kiến trúc giải pháp", "Code Review", "Đào tạo"],
                },
            ],
        },
        servicesPage: {
            eyebrow: "Dịch vụ",
            title: "Chúng tôi làm được gì cho bạn",
            sub: "Sáu mảng năng lực cốt lõi, một tiêu chuẩn duy nhất: kỹ thuật chính xác và kết quả đo lường được.",
            processEyebrow: "Quy trình",
            processTitle: "5 bước từ ý tưởng đến vận hành",
            steps: [
                { title: "Khám phá & Phân tích", desc: "Lắng nghe bài toán, phân tích yêu cầu và đề xuất giải pháp kỹ thuật phù hợp nhất với ngân sách." },
                { title: "Thiết kế & Kiến trúc", desc: "Thiết kế UI/UX, kiến trúc hệ thống và lộ trình phát triển chi tiết theo từng giai đoạn." },
                { title: "Phát triển & Kiểm thử", desc: "Lập trình theo sprint, review code chéo, kiểm thử tự động và demo định kỳ hàng tuần." },
                { title: "Triển khai & Bàn giao", desc: "Deploy lên môi trường production, bàn giao đầy đủ mã nguồn, tài liệu và đào tạo vận hành." },
                { title: "Vận hành & Hỗ trợ", desc: "Giám sát, bảo trì và phát triển tính năng mới theo nhu cầu thực tế của doanh nghiệp." },
            ],
        },
        projects: {
            items: [
                {
                    id: "tempmail",
                    name: "Temp Mail",
                    category: "Sản phẩm nội bộ · Công cụ bảo mật",
                    status: "Đang vận hành",
                    live: true,
                    desc: "Nền tảng email tạm thời giúp người dùng nhận thư mà không tiết lộ địa chỉ thật — chống spam, bảo vệ danh tính, không cần đăng ký.",
                    highlights: [
                        "Tạo địa chỉ email tức thì chỉ với một cú click",
                        "Hộp thư tự hủy sau thời gian quy định",
                        "Không lưu trữ dữ liệu cá nhân người dùng",
                        "API công khai cho nhà phát triển tích hợp",
                    ],
                    tech: ["Node.js", "React", "SMTP Server", "Redis"],
                },
                {
                    id: "commerce",
                    name: "MAXTH Commerce Hub",
                    category: "Giải pháp doanh nghiệp · Thương mại điện tử",
                    status: "Đã bàn giao",
                    live: false,
                    desc: "Nền tảng thương mại điện tử đa kênh: quản lý sản phẩm, đơn hàng, tồn kho và thanh toán trong một bảng điều khiển duy nhất.",
                    highlights: [
                        "Đồng bộ đơn hàng từ nhiều sàn về một nơi",
                        "Báo cáo doanh thu thời gian thực",
                        "Tích hợp cổng thanh toán và đơn vị vận chuyển",
                    ],
                    tech: ["Next.js", "PostgreSQL", "GraphQL"],
                },
                {
                    id: "fleetops",
                    name: "FleetOps",
                    category: "Logistics · Thời gian thực",
                    status: "Đã bàn giao",
                    live: false,
                    desc: "Hệ thống điều phối và theo dõi đội xe thời gian thực với bản đồ trực quan, tối ưu lộ trình và cảnh báo tự động.",
                    highlights: [
                        "Theo dõi vị trí GPS cập nhật mỗi 5 giây",
                        "Tối ưu lộ trình giao hàng tự động",
                        "Cảnh báo quá giờ, quá tải và sai tuyến",
                    ],
                    tech: ["Go", "WebSocket", "PostGIS"],
                },
                {
                    id: "medisync",
                    name: "MediSync",
                    category: "Y tế · Quản lý phòng khám",
                    status: "Đã bàn giao",
                    live: false,
                    desc: "Phần mềm quản lý phòng khám: lịch hẹn, hồ sơ bệnh án điện tử, kê đơn thuốc và báo cáo doanh thu chi tiết.",
                    highlights: [
                        "Hồ sơ bệnh án điện tử bảo mật nhiều lớp",
                        "Nhắc lịch tái khám tự động qua SMS/email",
                        "Phân quyền chi tiết cho bác sĩ và lễ tân",
                    ],
                    tech: ["React", "NestJS", "MongoDB"],
                },
            ],
        },
        projectsPage: {
            eyebrow: "Dự án",
            title: "Những hệ thống chúng tôi đã xây",
            sub: "Từ sản phẩm nội bộ phục vụ cộng đồng đến các hệ thống doanh nghiệp vận hành mỗi ngày.",
            techLabel: "Công nghệ sử dụng",
            highlightsLabel: "Điểm nổi bật",
            visit: "Truy cập website",
        },
        blog: {
            posts: [
                {
                    slug: "microservices-hay-monolith",
                    title: "Microservices hay Monolith: chọn kiến trúc nào cho sản phẩm của bạn?",
                    category: "Kiến trúc",
                    date: "12/06/2026",
                    readTime: "6 phút đọc",
                    excerpt:
                        "Không có kiến trúc nào là chân lý tuyệt đối. Bài viết phân tích kinh nghiệm thực tế của đội ngũ MAXTH sau nhiều năm xây dựng cả hai mô hình.",
                    body: [
                        "Cuộc tranh luận giữa microservices và monolith chưa bao giờ ngừng nóng trong giới kỹ thuật. Nhưng tại MAXTH, chúng tôi tin rằng câu hỏi đúng không phải là \"kiến trúc nào tốt hơn\", mà là \"kiến trúc nào phù hợp với giai đoạn hiện tại của sản phẩm\".",
                        "Với các sản phẩm ở giai đoạn đầu, một monolith được tổ chức tốt — module hóa rõ ràng, ranh giới domain chặt chẽ — gần như luôn thắng về tốc độ phát triển. Bạn deploy một lần, debug một nơi, và không phải trả chi phí vận hành cho hạ tầng phân tán.",
                        "Microservices chỉ thực sự phát huy giá trị khi đội ngũ đủ lớn, khi các phần của hệ thống có yêu cầu scale khác nhau, và khi bạn đã có văn hóa DevOps đủ trưởng thành. Tách service quá sớm là một trong những sai lầm đắt giá nhất mà chúng tôi từng chứng kiến ở các dự án khách hàng.",
                        "Lời khuyên của chúng tôi: bắt đầu với một modular monolith, đo lường mọi thứ, và chỉ tách service khi con số chứng minh rằng bạn cần điều đó. Kiến trúc tốt là kiến trúc phục vụ tốc độ kinh doanh — không phải ngược lại.",
                    ],
                },
                {
                    slug: "triet-ly-privacy-first",
                    title: "Privacy-first: triết lý đằng sau Temp Mail",
                    category: "Bảo mật",
                    date: "28/05/2026",
                    readTime: "5 phút đọc",
                    excerpt:
                        "Tại sao chúng tôi xây dựng một dịch vụ email tạm thời không cần đăng ký, không lưu dữ liệu? Câu trả lời nằm ở triết lý thiết kế hệ thống của MAXTH.",
                    body: [
                        "Mỗi ngày, hàng triệu người dùng internet bị buộc phải đánh đổi địa chỉ email thật chỉ để đọc một bài viết, tải một tài liệu hay dùng thử một phần mềm. Hậu quả là hộp thư ngập spam và nguy cơ rò rỉ dữ liệu cá nhân.",
                        "Temp Mail ra đời từ một câu hỏi đơn giản: điều gì sẽ xảy ra nếu việc bảo vệ danh tính trực tuyến chỉ mất một cú click? Chúng tôi thiết kế hệ thống theo nguyên tắc privacy-first: không đăng ký, không cookie theo dõi, hộp thư tự hủy và không một byte dữ liệu cá nhân nào được lưu lại.",
                        "Về mặt kỹ thuật, điều này đòi hỏi nhiều quyết định khó: kiến trúc stateless hoàn toàn, SMTP server tự xây dựng, và chính sách retention ở mức tối thiểu. Nhưng đó chính là cách chúng tôi chứng minh rằng bảo mật không phải là tính năng cộng thêm — mà là nền tảng.",
                        "Temp Mail hiện đang phục vụ hàng nghìn lượt sử dụng mỗi tháng tại maxthsolutions.org, và là minh chứng rõ nhất cho năng lực kỹ thuật mà MAXTH mang lại cho khách hàng.",
                    ],
                },
                {
                    slug: "toi-uu-hieu-nang-web",
                    title: "Từ 4 giây xuống 400ms: hành trình tối ưu hiệu năng web",
                    category: "Hiệu năng",
                    date: "15/05/2026",
                    readTime: "8 phút đọc",
                    excerpt:
                        "Một dự án thực tế của MAXTH: cách chúng tôi cải thiện tốc độ tải trang gấp 10 lần cho một nền tảng thương mại điện tử — và bài học rút ra.",
                    body: [
                        "Khi tiếp nhận hệ thống, nền tảng thương mại điện tử của khách hàng mất trung bình 4 giây để render trang sản phẩm. Với ngành bán lẻ, mỗi giây chậm trễ tương đương hàng chục phần trăm khách hàng rời bỏ.",
                        "Chúng tôi bắt đầu bằng việc đo lường thay vì phỏng đoán: waterfall analysis cho thấy 60% thời gian nằm ở các truy vấn database N+1 và bundle JavaScript gần 2MB. Không có giải pháp tổng thể nào — chỉ có hàng chục tối ưu nhỏ được xếp theo thứ tự tác động.",
                        "Kết quả sau 6 tuần: truy vấn được tổng hợp và cache bằng Redis, bundle được code-split theo route, hình ảnh chuyển sang WebP với lazy loading, và CDN phục vụ toàn bộ static assets. Thời gian tải xuống còn 400ms ở percentile 75.",
                        "Bài học lớn nhất: hiệu năng không phải là một giai đoạn trong dự án, mà là một thói quen kỹ thuật. Đo lường liên tục, đặt ngân sách hiệu năng ngay từ ngày đầu, và đừng bao giờ tối ưu thứ bạn chưa đo.",
                    ],
                },
                {
                    slug: "ci-cd-cho-team-nho",
                    title: "CI/CD cho team nhỏ: ít công cụ, nhiều giá trị",
                    category: "DevOps",
                    date: "02/05/2026",
                    readTime: "5 phút đọc",
                    excerpt:
                        "Bạn không cần một bộ máy DevOps phức tạp để deploy tự tin mỗi ngày. Đây là thiết lập CI/CD tối giản mà MAXTH áp dụng cho các dự án vừa và nhỏ.",
                    body: [
                        "Nhiều team nhỏ trì hoãn việc xây dựng CI/CD vì nghĩ rằng nó đòi hỏi Kubernetes, hệ thống giám sát phức tạp và một kỹ sư DevOps riêng. Thực tế, 80% giá trị của CI/CD đến từ 20% thiết lập đơn giản nhất.",
                        "Công thức tối giản của chúng tôi gồm ba thành phần: một pipeline chạy test tự động trên mỗi pull request, một bước build và deploy tự động khi merge vào nhánh chính, và khả năng rollback chỉ với một lệnh. Tất cả có thể dựng trong một ngày với GitHub Actions hoặc GitLab CI.",
                        "Điều quan trọng hơn công cụ là kỷ luật: không merge khi test đỏ, không deploy thủ công, và luôn viết migration có thể rollback. Những quy tắc này miễn phí nhưng giá trị hơn bất kỳ công cụ đắt tiền nào.",
                        "Khi nền móng đã vững, việc mở rộng lên canary deployment, feature flags hay auto-scaling chỉ là bước tiến hóa tự nhiên. Hãy bắt đầu nhỏ — nhưng hãy bắt đầu ngay hôm nay.",
                    ],
                },
            ],
        },
        blogPage: {
            eyebrow: "Blog kỹ thuật",
            title: "Ghi chép từ phòng lab MAXTH",
            sub: "Kinh nghiệm thực chiến về kiến trúc, hiệu năng, bảo mật và văn hóa kỹ thuật — được viết bởi chính đội ngũ kỹ sư của chúng tôi.",
            back: "Quay lại Blog",
            relatedCta: "Bạn có bài toán tương tự cần giải quyết?",
            relatedCtaButton: "Trao đổi với đội ngũ",
        },
        aboutPage: {
            eyebrow: "Giới thiệu",
            title: "Đội ngũ kỹ sư đặt chất lượng lên hàng đầu",
            sub: "MAXTH Solutions là công ty TNHH Công nghệ và Nguồn lực MAXTH — đơn vị phát triển phần mềm tại TP. Hồ Chí Minh, phục vụ khách hàng trong và ngoài nước.",
            storyEyebrow: "Câu chuyện",
            storyTitle: "Bắt đầu từ niềm tin vào kỹ thuật đúng chuẩn",
            storyP1:
                "MAXTH Solutions được thành lập tại TP. Hồ Chí Minh bởi những kỹ sư phần mềm từng làm việc qua nhiều hệ thống lớn — và chứng kiến quá nhiều dự án thất bại vì những quyết định kỹ thuật cẩu thả. Chúng tôi muốn xây một công ty nơi chất lượng kỹ thuật là điều kiện tiên quyết, không phải lựa chọn.",
            storyP2:
                "Khác với mô hình gia công đại trà, MAXTH tiếp nhận số lượng dự án có chọn lọc và đồng hành sâu cùng khách hàng: từ phân tích bài toán, thiết kế kiến trúc, phát triển, triển khai cho đến vận hành dài hạn. Mỗi hệ thống bàn giao đều kèm đầy đủ mã nguồn, tài liệu và cam kết hỗ trợ.",
            storyP3:
                "Niềm tin đó được chứng minh bằng chính sản phẩm của chúng tôi — Temp Mail tại maxthsolutions.org — một nền tảng bảo mật phục vụ hàng nghìn người dùng, được xây dựng và vận hành hoàn toàn bởi đội ngũ nội bộ.",
            factsEyebrow: "Thông tin pháp lý",
            factsTitle: "Thông tin công ty",
            facts: [
                { label: "Tên đầy đủ", value: "Công ty TNHH Công nghệ và Nguồn lực MAXTH" },
                { label: "Tên tiếng Anh", value: "MAXTH Technology & Resources Co., Ltd." },
                { label: "Mã số thuế", value: "0319622735" },
                { label: "Địa chỉ", value: "236/13A Điện Biên Phủ, Phường Gia Định, TP. Hồ Chí Minh" },
                { label: "Email", value: "admin@maxthsolutions.org" },
                { label: "Lĩnh vực", value: "Phát triển phần mềm & Giải pháp công nghệ" },
            ],
            valuesEyebrow: "Giá trị cốt lõi",
            valuesTitle: "Bốn nguyên tắc không thỏa hiệp",
            values: [
                { title: "Chính xác tuyệt đối", desc: "Mỗi dòng code đều được review, mỗi tính năng đều được kiểm thử. Chúng tôi không bàn giao thứ mình không tự tin." },
                { title: "Minh bạch toàn diện", desc: "Tiến độ, chi phí, rủi ro — mọi thứ đều hiển thị rõ ràng trên bảng công việc chung với khách hàng." },
                { title: "Bảo mật mặc định", desc: "An toàn dữ liệu không phải tính năng cộng thêm, mà là nền tảng của mọi hệ thống chúng tôi xây dựng." },
                { title: "Đồng hành dài hạn", desc: "Dự án kết thúc là lúc quan hệ đối tác bắt đầu. Chúng tôi ở lại cùng sản phẩm sau bàn giao." },
            ],
            missionTitle: "Sứ mệnh của chúng tôi",
            missionText:
                "Mang kỹ thuật phần mềm đẳng cấp quốc tế đến gần hơn với doanh nghiệp Việt Nam — và đưa sản phẩm công nghệ Việt vươn ra thế giới.",
        },
        contact: {
            eyebrow: "Liên hệ",
            title: "Bắt đầu cuộc trò chuyện",
            sub: "Kể cho chúng tôi về dự án của bạn — càng chi tiết càng tốt. Chúng tôi cam kết phản hồi trong vòng 24 giờ làm việc.",
            infoTitle: "Thông tin liên hệ",
            addressLabel: "Địa chỉ",
            emailLabel: "Email",
            taxLabel: "Mã số thuế",
            hoursLabel: "Giờ làm việc",
            hoursValue: "Thứ 2 – Thứ 7 · 9:00 – 18:00",
            formTitle: "Gửi tin nhắn cho chúng tôi",
            nameLabel: "Họ và tên",
            namePlaceholder: "Nguyễn Văn A",
            emailPlaceholder: "ban@congty.vn",
            phoneLabel: "Số điện thoại (không bắt buộc)",
            phonePlaceholder: "09xx xxx xxx",
            messageLabel: "Nội dung",
            messagePlaceholder: "Mô tả ngắn gọn về dự án, mục tiêu và thời gian mong muốn...",
            submit: "Gửi tin nhắn",
            sending: "Đang gửi...",
            successTitle: "Đã gửi thành công!",
            successText: "Cảm ơn bạn đã liên hệ. Đội ngũ MAXTH sẽ phản hồi qua email trong vòng 24 giờ làm việc.",
            sendAnother: "Gửi tin nhắn khác",
            errorMsg: "Gửi không thành công. Vui lòng thử lại hoặc email trực tiếp về admin@maxthsolutions.org.",
            mapEyebrow: "Bản đồ",
            mapTitle: "Ghé thăm văn phòng MAXTH",
            mapCta: "Chỉ đường trên Google Maps",
        },
        tempmail: {
            demoLabel: "Demo mô phỏng",
            yourAddress: "Địa chỉ tạm thời của bạn",
            copy: "Sao chép",
            copied: "Đã sao chép vào clipboard",
            regenerate: "Tạo địa chỉ mới",
            inbox: "Hộp thư đến",
            emptyInbox: "Chưa có thư nào. Hộp thư sẽ tự động làm mới.",
            autoDestroy: "Tự hủy sau",
            demoSubject: "Chào mừng bạn đến với Temp Mail",
            demoPreview: "Đây là email demo. Hộp thư thật sẽ hiển thị thư đến theo thời gian thực...",
            demoNote: "Bản demo mô phỏng giao diện — trải nghiệm đầy đủ tại maxthsolutions.org",
        },
        footer: {
            tagline:
                "Công ty phát triển phần mềm tại TP. Hồ Chí Minh — chuyên ứng dụng web, di động, hệ thống API và hạ tầng cloud.",
            colCompany: "Công ty",
            colMenu: "Điều hướng",
            colServices: "Dịch vụ",
            rights: "Bản quyền thuộc về MAXTH Solutions.",
            tax: "MST: 0319622735",
        },
        common: {
            langVi: "VI",
            langEn: "EN",
        },
    },
    en: {
        nav: {
            home: "Home",
            about: "About",
            services: "Services",
            projects: "Projects",
            blog: "Blog",
            contact: "Contact",
            cta: "Start a project",
        },
        home: {
            eyebrow: "MAXTH Technology & Resources Co., Ltd.",
            heroLine1: "Engineering software.",
            heroLine2: "Defining the digital future.",
            heroSub:
                "MAXTH Solutions is a software development company based in Ho Chi Minh City. We design and build web applications, mobile apps and large-scale systems — international engineering standards, optimized for Vietnamese businesses.",
            ctaPrimary: "Start a project",
            ctaSecondary: "Explore services",
            scrollHint: "Scroll down",
            stats: [
                { value: 20, suffix: "+", decimals: 0, label: "Projects delivered" },
                { value: 12, suffix: "+", decimals: 0, label: "Business partners" },
                { value: 99.9, suffix: "%", decimals: 1, label: "Uptime commitment" },
                { value: 24, suffix: "/7", decimals: 0, label: "Technical support" },
            ],
            aboutEyebrow: "About us",
            aboutTitle: "Precise engineering. Product thinking.",
            aboutText1:
                "MAXTH Solutions (Tax code: 0319622735) operates on a single belief: great software is born from precision in every line of code and a deep understanding of the client's business problem.",
            aboutText2:
                "From internal enterprise systems to products serving thousands of users like Temp Mail, we pursue uncompromising engineering quality — clear architecture, high performance, security by default.",
            aboutPoints: [
                "Battle-tested full-stack engineering team",
                "Transparent process with weekly progress reports",
                "Security and privacy as default priorities",
                "Full source code and documentation handover",
            ],
            aboutLink: "Learn more about MAXTH",
            servicesEyebrow: "Services",
            servicesTitle: "Full-spectrum engineering capability",
            servicesSub:
                "From idea to production — we take ownership of the entire software development lifecycle.",
            viewAllServices: "View all services",
            featuredEyebrow: "Featured product",
            featuredBadge: "Live",
            featuredText:
                "Temp Mail is a disposable email platform built and operated by the MAXTH team — letting users receive mail without exposing their real address, fighting spam and protecting online identity.",
            featuredPoints: [
                "Instant email address, no sign-up required",
                "Self-destructing inbox, zero personal data stored",
                "Minimal interface, sub-1-second load time",
                "Serving thousands of sessions every month",
            ],
            visitSite: "Try it at maxthsolutions.org",
            projectsEyebrow: "Projects",
            projectsTitle: "Products we have built",
            viewAllProjects: "View all projects",
            blogEyebrow: "Engineering blog",
            blogTitle: "Notes from the lab",
            viewAllBlog: "Read all articles",
            readMore: "Read more",
            ctaTitle: "Have an idea worth building?",
            ctaText:
                "Tell us about your problem. The MAXTH engineering team will respond within 24 business hours with a concrete solution proposal.",
            ctaButton: "Get in touch",
        },
        services: {
            items: [
                {
                    id: "web",
                    title: "Web Application Development",
                    desc: "Modern, fast-loading, SEO-ready and scalable web applications — from corporate portals to complex SaaS platforms.",
                    tags: ["React", "Next.js", "Node.js", "TypeScript"],
                },
                {
                    id: "mobile",
                    title: "Mobile App Development",
                    desc: "Native-feel iOS & Android apps from a single codebase, released simultaneously on both app stores.",
                    tags: ["React Native", "Flutter", "iOS", "Android"],
                },
                {
                    id: "api",
                    title: "API & Backend Systems",
                    desc: "REST/GraphQL API design, microservices architecture, handling millions of requests with low latency and horizontal scaling.",
                    tags: ["Node.js", "Python", "Go", "PostgreSQL", "Redis"],
                },
                {
                    id: "cloud",
                    title: "Cloud & DevOps",
                    desc: "Infrastructure on AWS/GCP, containerization with Kubernetes, automated CI/CD and comprehensive 24/7 monitoring.",
                    tags: ["AWS", "GCP", "Kubernetes", "Terraform"],
                },
                {
                    id: "security",
                    title: "Security & Privacy",
                    desc: "Security assessments, penetration testing and privacy-first system design — the same way we built Temp Mail.",
                    tags: ["Pen-testing", "OWASP", "Encryption", "Audit"],
                },
                {
                    id: "consulting",
                    title: "Digital Transformation Consulting",
                    desc: "Partnering with businesses from problem analysis and technology selection to implementation roadmaps and long-term operations.",
                    tags: ["Solution Architecture", "Code Review", "Training"],
                },
            ],
        },
        servicesPage: {
            eyebrow: "Services",
            title: "What we can do for you",
            sub: "Six core capability areas, one single standard: precise engineering and measurable outcomes.",
            processEyebrow: "Process",
            processTitle: "5 steps from idea to production",
            steps: [
                { title: "Discovery & Analysis", desc: "Listening to your problem, analyzing requirements and proposing the technical solution that best fits your budget." },
                { title: "Design & Architecture", desc: "UI/UX design, system architecture and a detailed development roadmap broken into phases." },
                { title: "Development & Testing", desc: "Sprint-based development, peer code review, automated testing and weekly demos." },
                { title: "Deployment & Handover", desc: "Production deployment, full source code and documentation handover, plus operations training." },
                { title: "Operations & Support", desc: "Monitoring, maintenance and new feature development based on your real business needs." },
            ],
        },
        projects: {
            items: [
                {
                    id: "tempmail",
                    name: "Temp Mail",
                    category: "In-house product · Privacy tool",
                    status: "Live",
                    live: true,
                    desc: "A disposable email platform that lets users receive mail without revealing their real address — anti-spam, identity protection, no sign-up.",
                    highlights: [
                        "Instant email address with a single click",
                        "Self-destructing inbox after a set period",
                        "Zero personal user data stored",
                        "Public API for developer integration",
                    ],
                    tech: ["Node.js", "React", "SMTP Server", "Redis"],
                },
                {
                    id: "commerce",
                    name: "MAXTH Commerce Hub",
                    category: "Enterprise solution · E-commerce",
                    status: "Delivered",
                    live: false,
                    desc: "A multi-channel e-commerce platform: products, orders, inventory and payments managed in a single dashboard.",
                    highlights: [
                        "Order sync from multiple marketplaces into one place",
                        "Real-time revenue reporting",
                        "Payment gateway and shipping carrier integration",
                    ],
                    tech: ["Next.js", "PostgreSQL", "GraphQL"],
                },
                {
                    id: "fleetops",
                    name: "FleetOps",
                    category: "Logistics · Real-time",
                    status: "Delivered",
                    live: false,
                    desc: "A real-time fleet dispatch and tracking system with visual maps, route optimization and automatic alerts.",
                    highlights: [
                        "GPS position tracking updated every 5 seconds",
                        "Automatic delivery route optimization",
                        "Overtime, overload and off-route alerts",
                    ],
                    tech: ["Go", "WebSocket", "PostGIS"],
                },
                {
                    id: "medisync",
                    name: "MediSync",
                    category: "Healthcare · Clinic management",
                    status: "Delivered",
                    live: false,
                    desc: "Clinic management software: appointments, electronic medical records, prescriptions and detailed revenue reports.",
                    highlights: [
                        "Multi-layer secured electronic medical records",
                        "Automatic follow-up reminders via SMS/email",
                        "Granular permissions for doctors and receptionists",
                    ],
                    tech: ["React", "NestJS", "MongoDB"],
                },
            ],
        },
        projectsPage: {
            eyebrow: "Projects",
            title: "Systems we have built",
            sub: "From in-house products serving the community to enterprise systems running every day.",
            techLabel: "Tech stack",
            highlightsLabel: "Highlights",
            visit: "Visit website",
        },
        blog: {
            posts: [
                {
                    slug: "microservices-hay-monolith",
                    title: "Microservices or Monolith: which architecture fits your product?",
                    category: "Architecture",
                    date: "Jun 12, 2026",
                    readTime: "6 min read",
                    excerpt:
                        "No architecture is an absolute truth. This article shares the MAXTH team's hands-on experience after years of building both models.",
                    body: [
                        "The debate between microservices and monoliths never cools down. But at MAXTH, we believe the right question is not \"which architecture is better\", but \"which architecture fits your product's current stage\".",
                        "For early-stage products, a well-organized monolith — clearly modularized with tight domain boundaries — almost always wins on development speed. You deploy once, debug in one place, and avoid the operational cost of distributed infrastructure.",
                        "Microservices only pay off when the team is large enough, when parts of the system have different scaling requirements, and when your DevOps culture is mature. Splitting services too early is one of the most expensive mistakes we have witnessed in client projects.",
                        "Our advice: start with a modular monolith, measure everything, and only extract services when the numbers prove you need to. Good architecture serves business velocity — not the other way around.",
                    ],
                },
                {
                    slug: "triet-ly-privacy-first",
                    title: "Privacy-first: the philosophy behind Temp Mail",
                    category: "Security",
                    date: "May 28, 2026",
                    readTime: "5 min read",
                    excerpt:
                        "Why did we build a disposable email service with no sign-up and no data retention? The answer lies in MAXTH's system design philosophy.",
                    body: [
                        "Every day, millions of internet users are forced to trade their real email address just to read an article, download a document or trial a piece of software. The result is spam-flooded inboxes and the risk of personal data leaks.",
                        "Temp Mail was born from a simple question: what if protecting your online identity took just one click? We designed the system around privacy-first principles: no registration, no tracking cookies, self-destructing inboxes, and not a single byte of personal data retained.",
                        "Technically, this demanded hard decisions: a fully stateless architecture, a self-built SMTP server, and minimal retention policies. But that is exactly how we prove security is not an add-on feature — it is the foundation.",
                        "Temp Mail now serves thousands of sessions every month at maxthsolutions.org, and stands as the clearest demonstration of the engineering capability MAXTH brings to its clients.",
                    ],
                },
                {
                    slug: "toi-uu-hieu-nang-web",
                    title: "From 4 seconds to 400ms: a web performance journey",
                    category: "Performance",
                    date: "May 15, 2026",
                    readTime: "8 min read",
                    excerpt:
                        "A real MAXTH engagement: how we improved page load speed tenfold for an e-commerce platform — and the lessons learned.",
                    body: [
                        "When we took over the system, the client's e-commerce platform averaged 4 seconds to render a product page. In retail, every second of delay costs a double-digit percentage of abandoning customers.",
                        "We started by measuring instead of guessing: waterfall analysis showed 60% of the time was spent on N+1 database queries and a JavaScript bundle of nearly 2MB. There was no silver bullet — only dozens of small optimizations ranked by impact.",
                        "After six weeks: queries were aggregated and cached with Redis, the bundle was code-split by route, images moved to WebP with lazy loading, and a CDN served all static assets. Load time dropped to 400ms at the 75th percentile.",
                        "The biggest lesson: performance is not a phase in a project, it is an engineering habit. Measure continuously, set performance budgets from day one, and never optimize what you have not measured.",
                    ],
                },
                {
                    slug: "ci-cd-cho-team-nho",
                    title: "CI/CD for small teams: fewer tools, more value",
                    category: "DevOps",
                    date: "May 2, 2026",
                    readTime: "5 min read",
                    excerpt:
                        "You don't need a complex DevOps machine to deploy confidently every day. Here is the minimal CI/CD setup MAXTH applies to small and mid-size projects.",
                    body: [
                        "Many small teams postpone CI/CD because they think it requires Kubernetes, complex monitoring stacks and a dedicated DevOps engineer. In reality, 80% of CI/CD's value comes from the simplest 20% of setup.",
                        "Our minimal formula has three components: a pipeline that runs tests automatically on every pull request, a build-and-deploy step when merging to the main branch, and one-command rollback. All of it can be set up in a day with GitHub Actions or GitLab CI.",
                        "More important than tooling is discipline: never merge on red tests, never deploy manually, and always write reversible migrations. These rules are free but worth more than any expensive tool.",
                        "Once the foundation is solid, evolving toward canary deployments, feature flags or auto-scaling is a natural next step. Start small — but start today.",
                    ],
                },
            ],
        },
        blogPage: {
            eyebrow: "Engineering blog",
            title: "Notes from the MAXTH lab",
            sub: "Hands-on experience on architecture, performance, security and engineering culture — written by our own engineers.",
            back: "Back to Blog",
            relatedCta: "Facing a similar problem?",
            relatedCtaButton: "Talk to our team",
        },
        aboutPage: {
            eyebrow: "About",
            title: "An engineering team that puts quality first",
            sub: "MAXTH Solutions is MAXTH Technology & Resources Co., Ltd. — a software development company in Ho Chi Minh City serving clients locally and globally.",
            storyEyebrow: "Our story",
            storyTitle: "Founded on a belief in proper engineering",
            storyP1:
                "MAXTH Solutions was founded in Ho Chi Minh City by software engineers who had worked on many large-scale systems — and witnessed too many projects fail because of careless technical decisions. We wanted to build a company where engineering quality is a prerequisite, not an option.",
            storyP2:
                "Unlike mass-market outsourcing, MAXTH takes on a selective number of projects and partners deeply with each client: from problem analysis and architecture design to development, deployment and long-term operations. Every system we deliver comes with full source code, documentation and a support commitment.",
            storyP3:
                "That belief is proven by our own product — Temp Mail at maxthsolutions.org — a privacy platform serving thousands of users, built and operated entirely by our in-house team.",
            factsEyebrow: "Legal information",
            factsTitle: "Company information",
            facts: [
                { label: "Full name", value: "MAXTH Technology & Resources Co., Ltd." },
                { label: "Vietnamese name", value: "Công ty TNHH Công nghệ và Nguồn lực MAXTH" },
                { label: "Tax code", value: "0319622735" },
                { label: "Address", value: "236/13A Dien Bien Phu, Gia Dinh Ward, Ho Chi Minh City" },
                { label: "Email", value: "admin@maxthsolutions.org" },
                { label: "Industry", value: "Software Development & Technology Solutions" },
            ],
            valuesEyebrow: "Core values",
            valuesTitle: "Four principles we never compromise",
            values: [
                { title: "Absolute precision", desc: "Every line of code is reviewed, every feature is tested. We do not ship anything we are not confident in." },
                { title: "Radical transparency", desc: "Progress, cost, risk — everything is visible on a shared project board with the client." },
                { title: "Security by default", desc: "Data safety is not an add-on feature; it is the foundation of every system we build." },
                { title: "Long-term partnership", desc: "A finished project is where the partnership begins. We stay with the product after handover." },
            ],
            missionTitle: "Our mission",
            missionText:
                "Bringing world-class software engineering closer to Vietnamese businesses — and taking Vietnamese technology products to the world.",
        },
        contact: {
            eyebrow: "Contact",
            title: "Start the conversation",
            sub: "Tell us about your project — the more detail, the better. We commit to responding within 24 business hours.",
            infoTitle: "Contact information",
            addressLabel: "Address",
            emailLabel: "Email",
            taxLabel: "Tax code",
            hoursLabel: "Working hours",
            hoursValue: "Mon – Sat · 9:00 – 18:00",
            formTitle: "Send us a message",
            nameLabel: "Full name",
            namePlaceholder: "John Doe",
            emailPlaceholder: "you@company.com",
            phoneLabel: "Phone (optional)",
            phonePlaceholder: "+84 9xx xxx xxx",
            messageLabel: "Message",
            messagePlaceholder: "Briefly describe your project, goals and desired timeline...",
            submit: "Send message",
            sending: "Sending...",
            successTitle: "Message sent!",
            successText: "Thank you for reaching out. The MAXTH team will reply via email within 24 business hours.",
            sendAnother: "Send another message",
            errorMsg: "Sending failed. Please try again or email us directly at admin@maxthsolutions.org.",
            mapEyebrow: "Map",
            mapTitle: "Visit the MAXTH office",
            mapCta: "Get directions on Google Maps",
        },
        tempmail: {
            demoLabel: "Simulated demo",
            yourAddress: "Your temporary address",
            copy: "Copy",
            copied: "Copied to clipboard",
            regenerate: "Generate new address",
            inbox: "Inbox",
            emptyInbox: "No mail yet. The inbox refreshes automatically.",
            autoDestroy: "Self-destructs in",
            demoSubject: "Welcome to Temp Mail",
            demoPreview: "This is a demo email. The real inbox displays incoming mail in real time...",
            demoNote: "Simulated interface demo — full experience at maxthsolutions.org",
        },
        footer: {
            tagline:
                "A software development company in Ho Chi Minh City — specializing in web & mobile applications, API systems and cloud infrastructure.",
            colCompany: "Company",
            colMenu: "Navigation",
            colServices: "Services",
            rights: "All rights reserved by MAXTH Solutions.",
            tax: "Tax code: 0319622735",
        },
        common: {
            langVi: "VI",
            langEn: "EN",
        },
    },
};
